'use client'

import { memo, useCallback } from 'react'
import Link from 'next/link'
import { CRAFT_MEDIA } from '@/app/ninxl/_components/craft-media'
import { NinTaglinePong } from './nin-tagline-pong'
import { NinCraftNamaste } from './nin-craft-namaste'

/**
 * baby: /nin first section: craft layout like /ninxl, but:
 * - title is Navigating India's Next (8-bit pong only)
 * - hero side card keeps Adam hands preview
 * - scroll beat below uses Namaste (closed → open)
 */
export const NinCraftHero = memo(function NinCraftHero() {
  const scrollTo = useCallback((id: string) => {
    const target =
      document.getElementById(id) ??
      document.querySelector<HTMLElement>(`[data-section="${id}"]`)
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <header className="craft-hero" aria-label="NIN: Navigating India's Next">
      <div className="craft-hero__grid">
        <div className="craft-reveal">
          <div className="craft-chip mb-4">OPEN SOURCE · YOUR DATA STAYS YOURS</div>

          {/* baby: only this tagline stays 8-bit; rest of hero is craft SF Pro */}
          <div className="nin-craft-pong">
            <NinTaglinePong />
          </div>

          <p className="craft-hero__headline">A sanctuary for users and their data.</p>
          <p className="craft-hero__support">
            Private desktop AI and mobile agents that protect what matters: by design, on your
            devices.
          </p>

          <div className="craft-hero__actions">
            <Link href="/ninxl" className="craft-btn craft-btn--primary">
              Explore NINX
            </Link>
            <button
              type="button"
              className="craft-btn craft-btn--ghost"
              onClick={() => scrollTo('projects')}
            >
              Explore
            </button>
          </div>

          <div className="craft-hero__meta" aria-label="Highlights">
            <span className="craft-chip">NINX desktop</span>
            <span className="craft-chip">NINK voice</span>
            <span className="craft-chip">Ningenie mobile</span>
          </div>
        </div>

        <div className="craft-hero__visual craft-reveal craft-reveal--d2">
          {/* baby: Keep Adam hands on the hero side card: do not swap for Namaste. */}
          <div className="craft-hero__frame nin-craft-adam-frame">
            <span className="craft-tape craft-tape--tl" aria-hidden />
            <span className="craft-tape craft-tape--tr" aria-hidden />
            <div className="nin-craft-adam-preview" aria-hidden>
              <img
                src={CRAFT_MEDIA.adam.handLeft}
                alt=""
                className="nin-craft-adam-preview__hand nin-craft-adam-preview__hand--left"
                draggable={false}
              />
              <div className="nin-craft-adam-preview__core">
                <img
                  src={CRAFT_MEDIA.adam.modelCore}
                  alt=""
                  className="nin-craft-adam-preview__model"
                  draggable={false}
                />
                <span className="nin-craft-adam-preview__label">On-device AI</span>
              </div>
              <img
                src={CRAFT_MEDIA.adam.handRight}
                alt=""
                className="nin-craft-adam-preview__hand nin-craft-adam-preview__hand--right"
                draggable={false}
              />
            </div>
          </div>
          <video
            className="craft-hero__accent"
            src={CRAFT_MEDIA.origamiVideo}
            poster={CRAFT_MEDIA.origamiPoster}
            muted
            playsInline
            autoPlay
            loop
            preload="metadata"
            aria-hidden
          />
        </div>
      </div>

      {/* baby: Namaste scroll only: opens outward below the Adam hero card. */}
      <NinCraftNamaste />
    </header>
  )
})

NinCraftHero.displayName = 'NinCraftHero'
